module.exports = __webpack_public_path__ + "img/Scheduling.6e1c555a.svg";